/* Jeux de Lumière — configurateur de néon (aperçu lumineux en direct).
   Modes : « neon » (fiche produit, texte), « logo » (fiche produit, logo envoyé), « demo » (section d'accueil).
   Règles : aucun MutationObserver sur le bouton d'ajout ; le bouton est désactivé (disabled) tant que le
   texte manque ; le bouton de paiement dynamique est masqué par la feuille de style. */
(function () {
  'use strict';
  if (window.jdlNeonInit) return;
  window.jdlNeonInit = true;

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* Ajuste la taille du texte pour qu'il tienne dans la scène (largeur et hauteur). */
  function fit(textEl, box) {
    if (!textEl || !box) return;
    var maxW = box.clientWidth * 0.84, maxH = box.clientHeight * 0.62;
    var size = Math.min(150, Math.max(28, box.clientWidth / 5));
    textEl.style.fontSize = size + 'px';
    var guard = 0;
    while ((textEl.scrollWidth > maxW || textEl.scrollHeight > maxH) && size > 14 && guard < 60) {
      size = size * 0.93; guard++;
      textEl.style.fontSize = size + 'px';
    }
  }

  function ignite(sign) {
    sign.classList.remove('is-igniting');
    void sign.offsetWidth; /* relance l'animation */
    sign.classList.add('is-igniting');
  }

  function setup(root) {
    if (root.__jn) return;
    root.__jn = true;
    var mode = root.getAttribute('data-jn-mode') || 'neon';
    var stage = $(root, '[data-jn-stage]');
    var sign = $(root, '[data-jn-sign]');
    var text = $(root, '[data-jn-text]');
    var input = $(root, '[data-jn-input]');
    var count = $(root, '[data-jn-count]');
    var colorName = $(root, '[data-jn-color-name]');
    var err = $(root, '[data-jn-err]');
    var form = root.closest('form');
    var addBtn = form ? form.querySelector('[name="add"], .add_to_cart, button[type="submit"]') : null;
    var defaultText = text ? text.textContent : '';

    function render() {
      if (!text) return;
      var v = input ? input.value.replace(/\r/g, '') : '';
      var lines = v.split('\n').slice(0, 3);
      if (input && v.split('\n').length > 3) { input.value = lines.join('\n'); }
      var shown = lines.join('\n').trim();
      text.textContent = shown || defaultText;
      text.classList.toggle('is-placeholder', !shown);
      if (count && input) count.textContent = input.value.length;
      fit(text, stage);
      lock();
    }

    function lock() {
      if (mode !== 'neon' || !addBtn || !input) return;
      var empty = input.value.trim() === '';
      addBtn.disabled = empty;
      addBtn.setAttribute('aria-disabled', empty ? 'true' : 'false');
      addBtn.classList.toggle('jn-locked', empty);
    }

    /* Police */
    $$(root, '[data-jn-font]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked || !text) return;
        text.style.fontFamily = "'" + r.getAttribute('data-jn-font') + "', cursive";
        setTimeout(function () { fit(text, stage); }, 60);
        ignite(sign);
      });
    });
    /* Couleur */
    $$(root, '[data-jn-color]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        sign.style.setProperty('--c', r.getAttribute('data-jn-color'));
        if (colorName) colorName.textContent = r.value;
        ignite(sign);
      });
    });
    /* Support */
    $$(root, '[data-jn-support]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) sign.setAttribute('data-support', r.getAttribute('data-jn-support')); });
    });
    /* Fond de la scène */
    $$(root, '[data-jn-bg]').forEach(function (b) {
      b.addEventListener('click', function () {
        stage.setAttribute('data-bg', b.getAttribute('data-jn-bg'));
        $$(root, '[data-jn-bg]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      });
    });
    /* Allumé / éteint */
    var power = $(root, '[data-jn-power]');
    if (power) power.addEventListener('click', function () {
      var on = !sign.classList.contains('is-on');
      sign.classList.toggle('is-on', on);
      power.classList.toggle('is-on', on);
      power.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = $(power, '[data-jn-power-label]'); if (l) l.textContent = on ? 'Allumé' : 'Éteint';
      if (on) ignite(sign);
    });

    /* Taille affichée : lue dans l'option de la variante choisie (« 60 cm », « 100 cm »...) */
    var variants = [];
    try { variants = JSON.parse(($(root, '[data-jn-variants]') || {}).textContent || '[]'); } catch (e) {}
    var sizeBox = $(root, '[data-jn-size]'), sizeLabel = $(root, '[data-jn-size-label]');
    function showSize() {
      if (!form || !sizeBox) return;
      var idEl = form.querySelector('[name="id"]');
      var id = idEl ? parseInt(idEl.value, 10) : 0;
      var v = variants.filter(function (x) { return x.id === id; })[0];
      var m = v ? (v.title || '').match(/(\d{2,3})\s*(cm|CM)/) : null;
      if (m) { sizeLabel.textContent = 'Largeur ' + m[1] + ' cm'; sizeBox.hidden = false; }
      else { sizeBox.hidden = true; }
    }
    if (form) {
      form.addEventListener('change', function (e) {
        if (!root.contains(e.target)) setTimeout(showSize, 30);
      });
      showSize();
    }

    /* Mode logo : affiche le fichier choisi dans le champ « Votre visuel » de bv-perso */
    if (mode === 'logo' && form) {
      var img = $(root, '[data-jn-logo-img]'), empty = $(root, '.jn__logo-empty');
      form.addEventListener('change', function (e) {
        var f = e.target && e.target.files && e.target.files[0];
        if (!f || !/^image\//.test(f.type) || !img) return;
        var rd = new FileReader();
        rd.onload = function () { img.src = rd.result; img.hidden = false; if (empty) empty.hidden = true; ignite(sign); };
        rd.readAsDataURL(f);
      });
    }

    /* Saisie */
    if (input) {
      input.addEventListener('input', render);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && input.value.split('\n').length >= 3) e.preventDefault();
      });
    }
    /* Garde au moment de l'ajout : texte obligatoire en mode néon */
    if (form && mode === 'neon') {
      form.addEventListener('submit', function (e) {
        if (input && input.value.trim() === '') {
          e.preventDefault(); e.stopImmediatePropagation();
          if (err) err.hidden = false; input.focus();
        }
      }, true);
      if (addBtn) addBtn.addEventListener('click', function (e) {
        if (input && input.value.trim() === '') {
          e.preventDefault(); e.stopImmediatePropagation();
          if (err) err.hidden = false; input.focus();
        }
      }, true);
    }

    /* Démo de la page d'accueil : texte qui s'écrit tout seul tant que le visiteur n'a pas tapé */
    if (mode === 'demo' && input) {
      var words = (root.getAttribute('data-jn-words') || '').split('|').filter(Boolean);
      var wi = 0, typing = null, touched = false;
      input.addEventListener('focus', function () { touched = true; if (typing) clearTimeout(typing); });
      (function cycle() {
        if (touched || !words.length) return;
        var w = words[wi % words.length], i = 0; wi++;
        (function step() {
          if (touched) return;
          input.value = w.slice(0, i); render();
          if (i++ < w.length) typing = setTimeout(step, 85);
          else typing = setTimeout(cycle, 2300);
        })();
      })();
      var link = $(root, '[data-jn-cta]');
      if (link) link.addEventListener('click', function () {
        try { sessionStorage.setItem('jdlNeonTexte', input.value || ''); } catch (e) {}
      });
    }
    /* Reprise du texte tapé sur l'accueil */
    if (mode === 'neon' && input && !input.value) {
      try { var saved = sessionStorage.getItem('jdlNeonTexte'); if (saved) input.value = saved; } catch (e) {}
    }

    render();
    ignite(sign);
    window.addEventListener('resize', function () { fit(text, stage); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(text, stage); });
  }

  function boot() { $$(document, '[data-jn]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
